import { render, staticRenderFns } from "./materSale_Detail.vue?vue&type=template&id=7968762c&"
import script from "./materSale_Detail.vue?vue&type=script&lang=js&"
export * from "./materSale_Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports